import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import cpApi from "@/lib/clientPortalApi";
import { useCpAuth } from "@/contexts/ClientPortalAuthContext";
import { Loader2 } from "lucide-react";

export default function CpChangePassword() {
  const { checkAuth } = useCpAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) return toast.error("Password must be at least 8 characters");
    if (newPassword !== confirm) return toast.error("Passwords do not match");
    setSubmitting(true);
    try {
      await cpApi.post("/client-portal/auth/change-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Password updated");
      await checkAuth();
      navigate("/client-portal/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Could not update password";
      toast.error(typeof msg === "string" ? msg : "Failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5 bg-white p-8 border border-slate-200 rounded-sm shadow-sm" data-testid="cp-change-pw-form">
        <div>
          <h2 className="text-xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>Set a new password</h2>
          <p className="text-xs text-slate-500 mt-1">For security, please change your initial password.</p>
        </div>
        <div className="space-y-1.5">
          <Label>Current password</Label>
          <Input type="password" value={currentPassword} required onChange={(e) => setCurrent(e.target.value)} data-testid="cp-cpw-current" />
        </div>
        <div className="space-y-1.5">
          <Label>New password (min 8)</Label>
          <Input type="password" value={newPassword} required onChange={(e) => setNew(e.target.value)} data-testid="cp-cpw-new" />
        </div>
        <div className="space-y-1.5">
          <Label>Confirm new password</Label>
          <Input type="password" value={confirm} required onChange={(e) => setConfirm(e.target.value)} data-testid="cp-cpw-confirm" />
        </div>
        <Button type="submit" disabled={submitting} className="w-full bg-[#0a2540] hover:bg-[#0a2540]/90" data-testid="cp-cpw-submit">
          {submitting ? <Loader2 className="animate-spin mr-2" size={16} /> : null}
          Update password
        </Button>
      </form>
    </div>
  );
}
